// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zaKT_0c3F2mUllAy1swL {
  display: flex;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  top: 2vw;
  left: 2vh;
}

.svaTD13rv8Xr4pu4NOws {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60%;
  height: 300px;
}

.RBFgoflOpd_fe45z5lGC {
  flex: 1;
  background-color: red;
  width: 60vw;
  height: auto;  
} 
`, "",{"version":3,"sources":["webpack://./src/Modals.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd","sourcesContent":[".container {\n  display: flex;\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  top: 2vw;\n  left: 2vh;\n}\n\n.item {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60%;\n  height: 300px;\n}\n\n.popup {\n  flex: 1;\n  background-color: red;\n  width: 60vw;\n  height: auto;  \n} \n"],"sourceRoot":""}]);
// Exports
export var container = `zaKT_0c3F2mUllAy1swL`;
export var item = `svaTD13rv8Xr4pu4NOws`;
export var popup = `RBFgoflOpd_fe45z5lGC`;
export default ___CSS_LOADER_EXPORT___;
